import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { editTipsActions } from "../../store/reducers/editTips";
import { useNavigate } from "react-router-dom";
import CircularLoader from "../CircularLoader";
import { Typography, Avatar } from "@mui/material";
import { useTranslation } from "react-i18next";
import CardButton from "../CardButton";
import {
  ConnectionsToken,
  RequestsToken,
  homeToken,
} from "../../utils/constant";
import { protocol, hostname, testimonialsApiUrl } from "../../utils/config";
import DynamicFont from "react-dynamic-font";
import { ReactComponent as CloseIcon } from "../../assests/icons/close_icon_transparent.svg";
import { ReactComponent as Addressicon } from "../../assests/icons/icon_address.svg";
import { ReactComponent as PhoneIcon } from "../../assests/icons/icon_phone_number.svg";
import { useGetRequests } from "../../utils/queries";
import { authHeaders, getSessionFromStorage } from "../../utils/session";
import {
  AddressBox,
  AddressText,
  AvtarCardBox,
  AvtarCardBoxWrap,
  ButtonBoxWrap,
  CloseIconBoxWrapLeft,
  CloseIconBoxWrapRight,
  DetailBoxWrap,
  DialogBoxWrap,
  ProfessionNameText,
} from "./Dialog.styles";

const MyConnectionDialogButton = ({
  btntype = "",
  value,
  onClickHandler = () => {},
}) => {
  const theme = useTheme();
  return (
    <Button
      onClick={onClickHandler}
      sx={{
        maxWidth: "250px",
        width: "100%",
        padding: "0.5rem 0.5rem",
        border: btntype === "grey" ? "2px solid #D9D9D9" : "2px solid #cf2030",
        color:
          btntype === "outlined"
            ? "#cf2030"
            : btntype === "grey"
            ? "#676767"
            : "#ffffff",
        background:
          btntype === "outlined"
            ? "#ffffff"
            : btntype === "grey"
            ? "#D9D9D9"
            : "#cf2030",
        visibility: btntype === "hidden" && "hidden",
        "&:hover": {
          background:
            btntype === "outlined"
              ? "#ffffff"
              : btntype === "grey"
              ? "#D9D9D9"
              : "#cf2030",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          textAlign: "center",
          span: {
            transformOrigin: theme.direction === "rtl" && "100% !important",
          },
        }}
      >
        <DynamicFont content={value} />
      </Box>
    </Button>
  );
};

const MyConnectionDetailDialog = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [loader, setLoader] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [testimonialUserAction, setTestimonialUserAction] = useState({});
  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const userData = useSelector((state) => state.dialog.dataObj);
  const connectionId = useSelector((state) => state.dialog.requestId);
  const getTestimonialActions = useGetRequests();

  const {
    profileImage,
    name,
    profession,
    secondaryCategory,
    requiredSpeciality,
    chapterName,
    connectionUser,
    address,
    phoneNumber,
    sameChapterMember,
  } = userData;

  const handleClose = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
  };

  const handleConnectConnectionRedirect = () => {
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(""));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
    alert("redirect connect");
  };

  const handleViewProfile = () => {
    window.location.href = `/web/secure/networkHome?userId=${connectionId}`;
    return;
  };

  const handleDeleteConnectionBtn = () => {
    setOpen(false);
    // dispatch(dialogActions.setIsDialogEnabled(false));
    setLoader(true);
    //  dispatch(dialogActions.setDialogType(""));
    setTimeout(() => {
      dispatch(dialogActions.setDialogType("deleteconnection"));
      setLoader(false);
    }, 1000);

    return;
  };

  const handleAskorGiveTestiomonial = (type) => {
    setOpen(false);
    dispatch(dialogActions.setDialogType(type));
    return;
  };

  const handleSendMessage = () => {
    window.location.href = `/web/secure/composeMessage?userId=${connectionId}&userName=${encodeURI(
      name
    )}&canRecipientListVisible=false`;
    return;
  };

  useEffect(() => {
    setLoader(true);
    setOpen(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    getTestimonialActions.mutate(
      {
        url: `${testimonialsApiUrl}status/${connectionId}`,
      },
      {
        mutationKey: "testimonialsGiveAsk",
        onSuccess: (success) => {
          if (success.status === 200) {
            setTestimonialUserAction(success.data.content);
            setLoader(false);
            dispatch(dialogActions.setIsDialogEnabled(true));
            setOpen(true);
          }
        },
        onError: (error) => {
          console.log(" api call error data my connections is ", error);
          alert(t(homeToken.GenericError));
        },
      }
    );
  }, []);

  return (
    <Box>
      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={false}
      >
        <DialogBoxWrap>
          {/* =========Card Start */}
          <AvtarCardBoxWrap>
            <AvtarCardBox>
              <Box
                sx={{
                  width: "7.8rem",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Avatar
                  alt={`${name} profile image`}
                  src={
                    profileImage
                      ? `${protocol}${hostname}:443//core-api/public/image/${profileImage}`
                      : `${name}`
                  }
                  sx={{ width: "10.4rem", height: "10.4rem" }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                  rowGap: "1rem",
                }}
              >
                <Typography
                  title={name ? `${name}` : " "}
                  sx={{
                    fontSize: "2rem",
                    color: "#cf2030",
                    width: "13rem",
                    textWrap: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    cursor: "default",
                    lineHeight: "normal",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  {name ? `${name}` : ""`${name}`}
                </Typography>
                <MyConnectionDialogButton
                  value={t(homeToken.ViewProfile)}
                  onClickHandler={handleViewProfile}
                  btntype="outlined"
                />
                {sameChapterMember ? (
                  <MyConnectionDialogButton
                    value={""}
                    onClickHandler={() => {}}
                    btntype="hidden"
                  />
                ) : (
                  <MyConnectionDialogButton
                    value={t(ConnectionsToken.DeleteConnection)}
                    onClickHandler={handleDeleteConnectionBtn}
                    btntype="grey"
                  />
                )}
              </Box>
            </AvtarCardBox>
            <CloseIconBoxWrapLeft>
              <CloseIcon
                fill={isHover ? "#cf2030" : "#64666A"}
                onClick={handleClose}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              />
            </CloseIconBoxWrapLeft>
          </AvtarCardBoxWrap>
          <DetailBoxWrap>
            <Box
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <ProfessionNameText
                  title={`${profession ? profession : " "} | ${
                    secondaryCategory ? secondaryCategory : " "
                  }${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`}
                  sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,             
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-word",        
                }}
                >
                  {profession && secondaryCategory
                    ? `${profession} | ${secondaryCategory}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
                    : profession
                    ? `${profession}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
                    : secondaryCategory
                    ? `${secondaryCategory}${requiredSpeciality?.trim() ? ` | ${requiredSpeciality}` : ""}`
                    : "\u00A0"}
                </ProfessionNameText>
                <Typography
                  sx={{
                    fontSize: "1.8rem",
                    color: "#cf2030",
                    // textAlign: "left",
                    cursor: "default",
                    lineHeight: "normal",
                  }}
                >
                  {`${chapterName ? chapterName : "\u00A0"}`}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "2rem",
                }}
              >
                <AddressBox>
                  <Box>
                    <Addressicon />
                  </Box>
                  <AddressText title={address}>{address}</AddressText>
                </AddressBox>
                <Box sx={{ display: "flex", columnGap: "2rem" }}>
                  <Box>
                    <PhoneIcon />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "1.2rem",
                      color: "#676767",
                      textAlign: "left",
                      cursor: "default",
                      textWrap: "wrap",
                    }}
                  >
                    {phoneNumber}
                  </Typography>
                </Box>
              </Box>
              <ButtonBoxWrap>
                {Object.keys(testimonialUserAction).length >= 1 &&
                  testimonialUserAction.canProvideRecommendation && (
                    <MyConnectionDialogButton
                      btntype={"outlined"}
                      value={t(ConnectionsToken.GiveTestimonial)}
                      onClickHandler={() =>
                        handleAskorGiveTestiomonial("givetestimonial")
                      }
                    />
                  )}
                {Object.keys(testimonialUserAction).length >= 1 &&
                  testimonialUserAction.canRequestRecommendation && (
                    <MyConnectionDialogButton
                      btntype={"outlined"}
                      value={t(ConnectionsToken.AskTestimonial)}
                      onClickHandler={() =>
                        handleAskorGiveTestiomonial("asktestimonial")
                      }
                    />
                  )}
                <MyConnectionDialogButton
                  value={t(homeToken.Sendmessage)}
                  onClickHandler={handleSendMessage}
                />
              </ButtonBoxWrap>
            </Box>
            <CloseIconBoxWrapRight>
              <CloseIcon
                fill={isHover ? "#cf2030" : "#64666A"}
                onClick={handleClose}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              />
            </CloseIconBoxWrapRight>
          </DetailBoxWrap>
          {/* =========Card End */}
        </DialogBoxWrap>
      </Dialog>
      {loader && <CircularLoader />}
    </Box>
  );
};

export default MyConnectionDetailDialog;
